// src/api/companyApi.js
import { apiRequest } from '@/api'

export const companyApi = {
  // 获取当前公司信息
  get() {
    return apiRequest('/api/company')
  },

  // 更新公司信息
  update(data) {
    return apiRequest('/api/company', {
      method: 'PUT',
      body: data
    })
  }
}